export interface CustomerModel {
  id?: any;
  name?: string;
  email?: string;
  billDestination?: string;
  contractNumber?: string;
  pricingModel?: number;
  customHeading1?: string;
  customHeading2?: string;
  customHeading3?: string;
  customHeading4?: string;
  customHeading5?: string;
  billingActive?: boolean;
  doUsageCollection?: boolean;
  doTonerMonitoring?: boolean;
  doTonerAutoOrder?: boolean;
  doInkMonitoring?: boolean;
  doInkAutoOrder?: boolean;
  doPrintHeadMonitoring?: boolean;
  doPrintHeadAutoOrder?: boolean;
  doMaintenanceMonitoring?: boolean;
  doMaintenanceAutoOrder?: boolean;
  doFastenerMonitoring?: boolean;
  doFastenerAutoOrder?: boolean;
  custAllSapServer?: boolean;
}

export function customerModelFactory(json?: any): CustomerModel {
  json = json || {};

  return {
    id: json.id,
    name: json.name || "",
    email: json.email || "",
    billDestination: json.billDestination || "",
    contractNumber: json.contractNumber || "",
    pricingModel: json.pricingModel || 0,
    customHeading1: json.customHeading1 || "",
    customHeading2: json.customHeading2 || "",
    customHeading3: json.customHeading3 || "",
    customHeading4: json.customHeading4 || "",
    customHeading5: json.customHeading5 || "",
    billingActive: json.billingActive || false,
    doUsageCollection: json.doUsageCollection || false,
    doTonerMonitoring: json.doTonerMonitoring || false,
    doTonerAutoOrder: json.doTonerAutoOrder || false,
    doInkMonitoring: json.doInkMonitoring || false,
    doInkAutoOrder: json.doInkAutoOrder || false,
    doPrintHeadMonitoring: json.doPrintHeadMonitoring || false,
    doPrintHeadAutoOrder: json.doPrintHeadAutoOrder || false,
    doMaintenanceMonitoring: json.doMaintenanceMonitoring || false,
    doMaintenanceAutoOrder: json.doMaintenanceAutoOrder || false,
    doFastenerMonitoring: json.doFastenerMonitoring || false,
    doFastenerAutoOrder: json.doFastenerAutoOrder || false,
    custAllSapServer: json.custAllSapServer || false,
  };
}
